import useTranslator from "../../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import { Button } from "../design";

const WelcomeModal = (props) => {
  const { isOpen, onClose, workspaceData, goToStepEight } = props;
  const { _t } = useTranslator();
  return (
    <Modal
      show={isOpen}
      onHide={() => {
        onClose();
        goToStepEight?.();
      }}
      centered
      id="welcome-modal-walkthrough"
      className="newmodalui max-w-lg tailwind-base-modal welcome-modal wrapper-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{_t("welcomeToYourNewWorkspace")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center">{_t("youHaveBeenAddedTo")} </p>

        <div className="workspaceName d-flex align-items-center justify-content-center">
          <h4>{workspaceData?.name?.substring(0, 1)}</h4>
        </div>

        <h3>{workspaceData?.name}</h3>
        <p className="text-center">
          {_t("youAreAllSetToCollaboratingAndStartWorkingOnThisWorkspace")}
        </p>
      </Modal.Body>
      <div className="inviteButtonWrapper">
        <Button
          variant="primary"
          size="lg"
          type="button"
          onClick={() => {
            onClose();
            goToStepEight?.();
          }}
        >
          {_t("startWorking")}
        </Button>
      </div>
    </Modal>
  );
};

export default WelcomeModal;
